import React from "react";

export interface CollectionProps {
  id: string;
}

export const Collection: React.FC<CollectionProps> = () => {
  return <></>;
};
